import React from "react";

export default function About() {
  return (
    <div>
      <span>About</span>
    </div>
  );
}
